import { render, staticRenderFns } from "./letter.vue?vue&type=template&id=b7d37a14"
import script from "./letter.vue?vue&type=script&lang=js"
export * from "./letter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports